/** Mammoth styleMap entries for Word → HTML conversion. */
export const MAMMOTH_STYLE_MAP = [
  "p[style-name='Heading 1'] => h1:fresh",
  "p[style-name='Heading 2'] => h2:fresh",
  "p[style-name='Heading 3'] => h3:fresh",
  "p[style-name='Heading 4'] => h4:fresh",
  "p[style-name='Heading 5'] => h5:fresh",
  "p[style-name='Heading 6'] => h6:fresh",
  "p[style-name='Title'] => h1:fresh",
  "p[style-name='Subtitle'] => h2:fresh",
  "p[style-name='Quote'] => blockquote:fresh",
  "p[style-name='Caption'] => p.caption:fresh",
  "p[style-name='List Paragraph'] => p:fresh",
  "p[style-name='Normal (Web)'] => p:fresh",
  "p[style-name='Normal'] => p:fresh",
  "p[style-name='Body Text'] => p:fresh",
  "p[style-name='Body Text Indent'] => p:fresh",
  "p[style-name='Center'] => p.center:fresh",
  "p[style-name='Right'] => p.right:fresh",
  "p[style-name='Justify'] => p.justify:fresh",
  // Direct paragraph alignment (w:jc) — injected by transformDocument
  "p[style-name='__lexgat_align_center'] => p.center:fresh",
  "p[style-name='__lexgat_align_right'] => p.right:fresh",
  "p[style-name='__lexgat_align_justify'] => p.justify:fresh",
  "p[style-name='__lexgat_align_left'] => p:fresh",
  "b => strong",
  "i => em",
  "u => u",
  "strike => s",
];
